var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hide",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.686,
    height: 17.744,
    viewBox: "0 0 22.686 15.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "unhide",
    d: "M33.821-805.188a4.3,4.3,0,0,0,3.161-1.3,4.3,4.3,0,0,0,1.3-3.161,4.3,4.3,0,0,0-1.3-3.161,4.3,4.3,0,0,0-3.161-1.3,4.3,4.3,0,0,0-3.161,1.3,4.3,4.3,0,0,0-1.3,3.161,4.3,4.3,0,0,0,1.3,3.161A4.3,4.3,0,0,0,33.821-805.188Zm0-2.079a2.3,2.3,0,0,1-1.689-.694,2.292,2.292,0,0,1-.7-1.686,2.3,2.3,0,0,1,.694-1.689,2.292,2.292,0,0,1,1.686-.7,2.3,2.3,0,0,1,1.689.694,2.292,2.292,0,0,1,.7,1.686,2.3,2.3,0,0,1-.694,1.689A2.292,2.292,0,0,1,33.824-807.268Zm0,5.489a11.685,11.685,0,0,1-6.868-2.161,12.326,12.326,0,0,1-4.475-5.712,12.327,12.327,0,0,1,4.475-5.711,11.685,11.685,0,0,1,6.868-2.161,11.685,11.685,0,0,1,6.868,2.161,12.327,12.327,0,0,1,4.475,5.711,12.326,12.326,0,0,1-4.475,5.712A11.685,11.685,0,0,1,33.821-801.779ZM33.821-809.651Zm0,5.454a9.338,9.338,0,0,0,5.115-1.482,9.793,9.793,0,0,0,3.568-3.972,9.79,9.79,0,0,0-3.57-3.972,9.344,9.344,0,0,0-5.116-1.482,9.338,9.338,0,0,0-5.115,1.482,9.793,9.793,0,0,0-3.568,3.972,9.79,9.79,0,0,0,3.57,3.972A9.344,9.344,0,0,0,33.822-804.2Z",
    transform: "translate(-22.478 817.523)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.561a41ca394e6d80eaf1782d672837dd.svg";
export { ForwardRef as ReactComponent };